module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/firenze.a02173fba305e1f0df1498d11f2e981d.jpg";